import { Injectable } from "@angular/core";
import { BaseHttpService } from "../base-http.service";
import { UserService } from "../user/user.service";
import { HttpClient } from "@angular/common/http";
import { CreateUserCombiOrderResult } from "../../model/createusercombiorderresult";
import { UserCombiOrderSettings } from "../../model/usercombiordersettings";
import { MessageService } from "../../modules/shared/message/message.service";
import { ProgressBarService } from "../../modules/shared/progress-bar/progress-bar.service";
import { CombiOrder, User } from "../../model";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class CombiOrderService extends BaseHttpService {

  constructor(protected http: HttpClient,
              protected userService: UserService,
              protected translateService: TranslateService,
              protected progressBarService: ProgressBarService,
              protected messageService: MessageService) {
    super(http, userService, translateService, progressBarService, messageService);
  }

  async createWithInvoice(user: User, userCombiOrderSettings: UserCombiOrderSettings): Promise<CreateUserCombiOrderResult> {
    return (await this.post<CreateUserCombiOrderResult>(`authenticated/combiorder/order`, {user, userCombiOrderSettings})).result;
  }

  async createWithCreditCardViaMollie(user: User, userCombiOrderSettings: UserCombiOrderSettings): Promise<CreateUserCombiOrderResult> {
    return (await this.post<CreateUserCombiOrderResult>(`authenticated/combiorder/orderviamollie`, {user, userCombiOrderSettings})).result;
  }

  async changeToAutomaticPayment(user: User, combiOrder: CombiOrder): Promise<CreateUserCombiOrderResult> {
    return (await this.post<CreateUserCombiOrderResult>(`authenticated/combiorder/payautomatically`, {user, combiOrder})).result;
  }

  async changePeriod(user: User, combiOrder: CombiOrder): Promise<CombiOrder> {
    return (await this.post<CombiOrder>(`authenticated/combiorder/changeperiod`, {user, combiOrder})).result;
  }

  async initiateMandateChange(user: User, combiOrder: CombiOrder): Promise<string | null> {
    return (await this.post<string>(`authenticated/combiorder/changemandate`, {user, combiOrder})).result ?? null;
  }
}
